module.exports = __webpack_public_path__ + "img/四川天府新区启慧幼儿园.befa20f0.jpg";